export default {
  nav: {
    home: '首页',
    products: '产品中心',
    about: '关于我们',
    contact: '联系我们'
  },
  header: {
    searchPlaceholder: '搜索产品...',
    contactSupplier: '联系供应商',
    language: '语言'
  },
  home: {
    categories: '产品分类',
    categoriesSub: '探索我们丰富的包装解决方案',
    products: '产品',
    whyChooseUs: '为什么选择我们',
    contactTitle: '联系我们获取更多信息！',
    contactSub: '为您的品牌定制专业包装解决方案',
    chatNow: '立即聊天',
    companyIntro: '公司简介',
    productionProcess: '制作流程',
    learnMore: '了解更多',
    reasonEquipment: '先进的生产设备',
    reasonTeam: '经验丰富的包装团队',
    reasonQuality: '严格的质量控制',
    reasonSample: '快速打样生产',
    reasonDelivery: '可靠的准时交付'
  },
  products: {
    allProducts: '全部产品',
    categories: '产品分类',
    searchPlaceholder: '搜索产品...',
    sortBy: '排序方式',
    sortDefault: '默认',
    sortName: '名称 A-Z',
    noProducts: '未找到产品',
    moq: '最小起订量',
    inquiryNow: '立即询价',
    details: '详情'
  },
  productDetail: {
    description: '产品描述',
    specifications: '产品规格',
    productDetails: '产品详情',
    sendInquiry: '发送询价',
    chatNow: '立即聊天',
    relatedProducts: '相关产品',
    productNotFound: '产品未找到',
    backToProducts: '返回产品列表'
  },
  about: {
    mainProducts: '主营产品',
    certifications: '资质证书',
    ourFactory: '工厂展示',
    factoryPrefix: '工厂',
    contactTitle: '联系我们获取更多信息！',
    contactSub: '为您的品牌定制专业包装解决方案',
    companyIntro: '公司简介',
    productionProcess: '制作流程'
  },
  contact: {
    title: '联系我们',
    subtitle: '如有任何产品或服务问题，请与我们联系',
    sendInquiry: '发送询价',
    contactInfo: '联系信息',
    name: '您的姓名',
    namePlaceholder: '请输入您的姓名',
    email: '电子邮箱',
    emailPlaceholder: '请输入您的邮箱',
    phone: '联系电话',
    phonePlaceholder: '请输入您的电话号码',
    company: '公司名称',
    companyPlaceholder: '请输入您的公司名称',
    productInterest: '感兴趣的产品',
    productPlaceholder: '请选择产品类别',
    message: '留言内容',
    messagePlaceholder: '请详细描述您的需求...',
    send: '发送询价',
    reset: '重置',
    address: '地址',
    fax: '传真',
    mapSoon: '地图即将上线',
    success: '询价发送成功！我们将尽快与您联系。',
    nameRequired: '请输入您的姓名',
    emailRequired: '请输入您的邮箱',
    emailInvalid: '请输入有效的邮箱地址',
    messageRequired: '请输入您的留言'
  },
  footer: {
    aboutUs: '关于我们',
    aboutText: '东莞彩诚印刷厂是一家拥有21年经验的专业包装制造商，专注于纸盒、礼品盒、纸袋等产品。',
    products: '产品',
    quickLinks: '快速链接',
    contactInfo: '联系信息',
    location: '中国广东省东莞市',
    allRightsReserved: '版权所有'
  },
  floating: {
    contact: '联系',
    chat: '聊天',
    top: '顶部'
  },
  categories: {
    mailerBox: '邮寄盒',
    magneticGiftBox: '磁吸礼盒',
    drawerBox: '抽屉盒',
    paperBag: '纸袋',
    paperCard: '纸卡',
    catalogue: '画册'
  }
}
